WiseMetering.Collection.Etls = WiseMetering.Collection.extend({
    hasOrganization: true,
    model: WiseMetering.Model.Etl,
    url: '/etls'
});
